/**
 * Q1 usability scale (1-5), reused verbatim from the reviewer-app
 * (`core-renew/reviewer-app/src/domain/types.ts`, `Q1_SCALE`). Every review
 * decision carries a Q1 score (required on approve AND reject, D2).
 *
 * The wording is the reviewer-app's; the i18n layer carries translated copies
 * keyed by value (`review.q1.scale.<n>.{label,description}`) so the panel can
 * show localised text while this stays the single source of the value list.
 */

export const Q1_SCALE = [
  { value: 1, label: "Unusable", description: "Completely wrong." },
  {
    value: 2,
    label: "Poor",
    description: "Salvageable but edit effort too high.",
  },
  {
    value: 3,
    label: "Acceptable but redundant",
    description: "Technically correct, too similar to be useful.",
  },
  {
    value: 4,
    label: "Good",
    description: "Usable with moderate edits (~10-30 min).",
  },
  {
    value: 5,
    label: "Excellent",
    description: "Usable as-is, minor edits (<5 min).",
  },
] as const;

export type Q1Score = 1 | 2 | 3 | 4 | 5;
